import axios from '../request/http';
import { toFormData } from '../common/descriptions';
const travel = {
    //端文章发布编辑
    scenicpage(params) {
        return axios.get('/hemei-admin/village/scenic/page', {params})
    },
    // 热门景点上下架
    updatestatus(data) {
        return axios.put('/hemei-admin/village/scenic/update/status', toFormData(data))
    },
    // 热门景点详情
    scenicId(params) {
        return axios.get(`/hemei-admin/village/scenic/${params.id}`, {params})
    },
    // 新增热门景点
    scenicadd(data) {
        return axios.post("/hemei-admin/village/scenic/add", data)
    },
    // 修改热门景点
    scenicedit(data) {
        return axios.put("/hemei-admin/village/scenic/edit", data)
    },
    // 删除热门景点
    scenicdelete(params) {
        return axios.delete("/hemei-admin/village/scenic/delete", {params})
    },
    // 获取推荐路径分页
    routepage(params) {
        return axios.get("/hemei-admin/village/route/page", {params})
    },
    // 推荐路径上下架
    routestatus(data) {
        return axios.put("/hemei-admin/village/route/update/status",  toFormData(data))
    },
    // 删除推荐路径
    routedelete(params) {
        return axios.delete("/hemei-admin/village/route/delete", {params})
    },
    // 推荐路径详情
    routeId(params) {
        return axios.get(`/hemei-admin/village/route/${params.id}`, {params})
    },
    // 修改推荐路径
    routedit(data) {
        return axios.put("/hemei-admin/village/route/edit", data)
    },
    // 新增推荐路径
    routadd(data) {
        return axios.post("/hemei-admin/village/route/add", data)
    },
    // 获取玩什么文章分页
    guidepage(params) {
        return axios.get("/hemei-admin/travel/guide/page", {params})
    },
    // 玩什么文章上下架
    guidestatus(data) {
        return axios.put("/hemei-admin/travel/guide/update/status",  toFormData(data))
    },
    // 删除玩什么文章
    guidedelete(params) {
        return axios.delete("/hemei-admin/travel/guide/delete", {params})
    },
    // 玩什么文章详情
    guideId(params) {
        return axios.get(`/hemei-admin/travel/guide/${params.id}`, {params})
    },
    // 景点详情列表
    scenicList(params){
        return axios.get("/hemei-admin/village/scenic/list", {params})
    },
    // 新增玩什么文章
    guideadd(data) {
        return axios.post("/hemei-admin/travel/guide/add", data)
    },
    // 修改玩什么文章
    guideedit(data) {
        return axios.put("/hemei-admin/travel/guide/edit",  data)
    },
    // 更新乡村旅游状态
    updateVillageTravelStatus(params){
        return axios.get("/hemei-admin/villageInfo/updateVillageTravelStatus", {params})
    },
    // 获取民宿审核列表
    getHomestayApplicationList(params){
        return axios.get("/hemei-admin/admin/homestay/getHomestayApplicationList", {params})
    },
    // 民宿审批接口
    homestayApproval(data) {
        return axios.post("/hemei-admin/admin/homestay/homestayApproval", data)
    },
    // 获取民宿详情
    getHomestayInfoDetail(params) {
        return axios.get("/hemei-admin/admin/homestay/getHomestayInfoDetail", {params})
    },
    // 获取民宿审批详情
    getHomestayApproveDetail(params) {
        return axios.get("/hemei-admin/admin/homestay/getHomestayApproveDetail", {params})
    },
    // 获取民宿列表
    getHomestayList(params) {
        return axios.get("/hemei-admin/admin/homestay/getHomestayList", {params})
    },
    // 更新民宿状态
    updateHomestayStatus(params) {
        return axios.get("/hemei-admin/admin/homestay/updateHomestayStatus", {params})
    },
    // 新建民宿
    addVillageHomestay(data) {
        return axios.post("/hemei-admin/admin/homestay/addVillageHomestay", data)
    },
    // 模糊搜索手机号
    getTelephoneList(params) {
        return axios.get("/service-user/user/getTelephoneList", {params})
    },
    // 根据手机号获取用户信息
    getUserInfoListVOByTelephone(params) {
        return axios.get("/service-user/user/getUserInfoListVOByTelephone", {params})
    },
    // 编辑民宿信息
    editHomestayInfo(data) {
        return axios.post("/hemei-admin/admin/homestay/editHomestayInfo", data)
    },
}
export default travel;